import { Reducer } from 'redux';

import { VariableStatsView } from '../../../lib/PlannerDTOs';
import { ActionType } from '../../../store/actionTypes';
import {
  EntityAction,
  ErrorAction,
  Action as PlainAction,
} from '../../../store/types';

export interface VariableStatsState {
  latestVariableStats: VariableStatsView;
  view: {
    expectData: boolean;
    loadingLatestVariableStats: boolean;
  };
}

export const initialState: VariableStatsState = {
  latestVariableStats: {
    name: '',
    scopes: {},
    updated_at: '',
  },
  view: {
    expectData: true,
    loadingLatestVariableStats: false,
  },
};

type Action =
  | PlainAction<ActionType.FETCH_LATEST_VARIABLESTATS_STARTED>
  | EntityAction<ActionType.FETCH_LATEST_VARIABLESTATS_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_LATEST_VARIABLESTATS_FAILED>;

const variableStatsReducer: Reducer<VariableStatsState, Action> = (
  state: VariableStatsState = initialState,
  action: Action,
) => {
  switch (action.type) {
    case ActionType.FETCH_LATEST_VARIABLESTATS_STARTED:
      return {
        ...state,
        view: {
          ...state.view,
          expectData: true,
          loadingLatestVariableStats: true,
        },
      };

    case ActionType.FETCH_LATEST_VARIABLESTATS_SUCCEEDED:
      return {
        ...state,
        latestVariableStats: {
          ...state.latestVariableStats,
        },
        view: {
          ...state.view,
          expectData: true,
          loadingLatestVariableStats: false,
        },
      };
    case ActionType.FETCH_LATEST_VARIABLESTATS_FAILED:
      if (action.payload.statusCode === 404) {
        return {
          ...state,
          view: {
            ...state.view,
            expectData: false,
            loadingLatestVariableStats: false,
          },
        };
      }
      return {
        ...state,
        view: {
          ...state.view,
          loadingLatestVariableStats: false,
        },
      };

    default:
      return state;
  }
};

export default variableStatsReducer;
